module.exports = __webpack_public_path__ + "img/havanna_oak_696l_list.44925fbb.jpg";